export default __webpack_public_path__ + "static/media/IMG_9873.f73c28e4.jpg";